interface Props {
  isLoading: boolean
  colSpan: number
  rejectedMessage?: string
  loaderMessage?: string
}

export const LoaderForTable = ({isLoading, colSpan, loaderMessage = 'Загрузка . . .', rejectedMessage = 'Нет элементов для отображения'}: Props) => {
    return (
        <tr>
            <td colSpan={colSpan} className='text-center'>
                {isLoading ? 
                    <span className='indicator-progress' style={{ display: 'block' }}>
                        <span className='spinner-border spinner-border-sm align-middle'></span>
                        {' '}
                        {loaderMessage}
                    </span>                                      
                : rejectedMessage}
            </td>
        </tr>
    )
}
